import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import NumberFormat from 'react-number-format';

import $ from 'jquery'

import axios from 'axios'
import querystring from 'querystring'

import {
    resetOrder,
    setQuantity
} from '../../modules/order'

import {
    setPriceTier,
    setCurrency
} from '../../modules/user'

import {
    addProduct
} from '../../modules/cart'

class ProductDetails extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    checkQuantity(event) {
        var value = event.target.value;
        value = value.replace(/\D/g,'');

        if(value.length === 0 || value < 0){
            value = 1;
        }

        this.props.setQuantity({
            quantity: value
        });
    }

    onPriceTierChange(event){

        const _this = this;

        axios.post(_this.props.config.api_path+'updateSessionPriceTier', querystring.stringify({
            price_tier: event.target.value
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

            if(response.data != null && "price_tier_multiplier" in response.data) {
                _this.props.setPriceTier({
                    price_tier: response.data.price_tier,
                    price_tier_multiplier: response.data.price_tier_multiplier,
                    price_tier_multiplier_dragonfly: response.data.price_tier_multiplier_dragonfly
                })
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    onCurrencyChange(event){

        const _this = this;

        if(this.props.user.user != null && "currencies" in this.props.user.user){

            var currency_allowed = false;
            var new_currency = null;

            this.props.user.user.currencies.map(function(element, key) {
                if(element.id == event.target.value){
                    currency_allowed = true;
                    new_currency = element;
                }
            });

            if(currency_allowed == true){

                this.props.setCurrency({
                    currency: new_currency
                });
            }
        }
    }

    onAddToCart(){

        var product = $.extend(true, {}, this.props.order.product);
        product.quantity = this.props.order.quantity;
        product.product_type = this.props.order.product_type;

        this.props.addProduct({
            product: product
        });

        $(".basket").removeClass("wobble");
        $(".basket").addClass("wobble");

        const _this = this;

        setTimeout(function () {
            _this.updateSessionCart();
        }, 1000);

    }

    onAddToList(){

        const _this = this;

        axios.post(_this.props.config.api_path+'api/writeProductToPriceList', querystring.stringify({
            product: JSON.stringify(this.props.order.product),
            optional_attributes: JSON.stringify(this.props.order.optional_attributes),
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type,
            fiber_type: this.props.order.fiber_type,
            cable_type: this.props.order.cable_type,
            cable_length: this.props.order.cable_length,
            packaging_type: this.props.order.packaging_type,
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

            $("#product_list_success").html("Added Product to Price List");

            setTimeout(function() {
                $("#product_list_success").html("");
            }, 2000);

        })
        .catch(function (error) {
            console.log(error);
        });
    }

    updateSessionCart(){

        const _this = this;

        axios.post(_this.props.config.api_path+'updateSessionCart', querystring.stringify({
            cart: JSON.stringify(this.props.cart.items)
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

        })
        .catch(function (error) {
            console.log(error);
        });
    }

    hideProductDetails() {
        $('.extender').fadeOut();
    }

    resetOrder() {
        const { history } = this.props;
        history.push('/ProductType');
        this.props.resetOrder();
        $('.extender').fadeOut();
    }

    render() {

        var optional_attributes = this.props.order.optional_attributes;

        var price_tiers = null;
        var price_tiers_table = null;

        if(this.props.user.user !== null && "price_tiers" in this.props.user.user){
            var price_tiers = this.props.user.user.price_tiers.map(function(element, key) {
                return (<option key={"PriceTier"+key} value={element.id}>{element.name}</option>);
            });
        }

        if(this.props.user.user !== null && this.props.user.currency !== null && "price_tiers" in this.props.user.user && this.props.order.product !== null && "price" in this.props.order.product){

            var price = this.props.order.product.price;
            var currency = this.props.user.currency.symbol;
            var conversion_factor = this.props.user.currency.conversion_factor;
            var tps_factor = this.props.user.currency.tps_factor;

            const _this = this;

            var price_tiers_table = this.props.user.user.price_tiers.map(function(element, key) {
                return (<tr key={"PriceTierTr"+key}>
                    <td>{element.name}</td>
                    <td>{currency + ' '}
                        <NumberFormat
                            value={(((_this.props.order.product_type === "dragonfly" ? element.multiplier_dragonfly : element.multiplier) * conversion_factor * (_this.props.order.product_type === "dragonfly" ? 1 : tps_factor) * price) + (_this.props.order.product.attribute_price * conversion_factor))}
                            displayType={'text'} thousandSeparator={"'"} decimalSeparator={"."}
                            decimalScale={2} fixedDecimalScale={true} />
                    </td>
                </tr>);
            });

        }

        var currencies = null;

        if(this.props.user.user !== null && "currencies" in this.props.user.user){
            var currencies = this.props.user.user.currencies.map(function(element, key) {
                return (<option key={"Currency"+key} value={element.id}>{element.name}</option>);
            });
        }

        return (
            <div className="extender">

                <div className="item-container">

                    <div className="appVersion">V {this.props.user.app_version}</div>


                    <div className="item-heading">Part Number and Specifications</div>

                    <table className="part" cellPadding="0" cellSpacing="0">
                        <tbody>
                        <tr className="partno">
                            <td>Part Number:</td>
                            <td>{ this.props.order.product !== null && "number" in this.props.order.product ? this.props.order.product.number : "Please choose more options"}</td>
                        </tr>
                        <tr>
                            <td>Attributes:</td>
                            <td>
                                { this.props.order.product !== null && "optional_attributes_text" in this.props.order.product ? this.props.order.product.optional_attributes_text : ""}
                            </td>
                        </tr>
                        <tr>
                            <td>Your Price:</td>
                            { this.props.user.user !== null && this.props.user.currency !== null && this.props.order.product !== null && "price" in this.props.order.product ?
                                <td>
                                    {this.props.user.currency.symbol + ' '}

                                    <NumberFormat
                                        value={(this.props.order.quantity * parseFloat((this.props.order.product.price * (this.props.order.product_type === "dragonfly" ? this.props.user.price_tier_multiplier_dragonfly : this.props.user.price_tier_multiplier)  * this.props.user.currency.conversion_factor * (this.props.order.product_type === "dragonfly" ? 1 : this.props.user.currency.tps_factor)) + (this.props.order.product.attribute_price * this.props.user.currency.conversion_factor)).toFixed(2))}
                                        displayType={'text'} thousandSeparator={"'"} decimalSeparator={"."}
                                        decimalScale={2} fixedDecimalScale={true} />
                                </td> :
                                <td>
                                    {(this.props.user.user !== null ? '' : "Please contact your local sales person for price information.")}
                                </td>
                            }
                        </tr>
                        </tbody>
                    </table>
                    <div className="row">
                        <div className="col-dt-50 col-mob-100">
                            Quantity:
                            <input type="text" className="quantity" placeholder="(pcs.)" name="quantity" id="quantity" value={this.props.order.quantity} onChange={(e) => this.checkQuantity(e)} />
                        </div>
                        { price_tiers !== null &&
                        <div className="col-dt-50 align-right col-mob-100">
                            Price Tier:
                            <select id="price_tier" value={this.props.user.price_tier} onChange={(e) => this.onPriceTierChange(e)}>
                                {price_tiers}
                            </select>
                        </div>
                        }
                    </div>
                    <div className="divider"></div>
                    { this.props.user.user !== null && this.props.user.user.internal === true &&
                    <div className="row">
                        <div className="col-dt-50 col-mob-100">
                            For internal users only.

                        </div>
                        { currencies !== null && this.props.user.currency !== null &&
                        <div className="col-dt-50 align-right col-mob-100">
                            Currency
                            <select value={this.props.user.currency.id} onChange={(e) => this.onCurrencyChange(e)}>
                                {currencies}
                            </select>

                        </div>
                        }
                    </div>
                    }
                    { this.props.order.product !== null && "number" in this.props.order.product &&
                    <div>
                        <div className="divider"></div>
                        <div className="row">
                            <div className="col-dt-50 col-mob-100">
                                <div className="align-left">
                                    <button type="button" className="cancel" onClick={() => this.resetOrder()}>Cancel and reset configurator</button>
                                </div>
                            </div>
                            {this.props.user.user !== null &&
                            <div className="col-dt-50 col-mob-100">
                                <div className="align-right">
                                    <button type="button" onClick={() => this.onAddToCart()}>Add product to cart »</button>

                                    { this.props.user.user !== null && this.props.user.user.internal === true &&
                                    <div>
                                        <button type="button" onClick={() => this.onAddToList()} style={{marginTop: '10px'}}>&nbsp;Add product to list »</button>
                                        <div id="product_list_success" style={{marginTop: '10px'}}></div>
                                    </div>
                                    }

                                </div>

                            </div>
                            }
                        </div>

                        <div className="item-heading">Product Details</div>
                        <table cellPadding="0" cellSpacing="0" className="parts">
                            <thead>
                            <tr>
                                <th>Category</th>
                                <th>Configuration</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td rowSpan="2">Insertion Loss:</td>
                                <td className="noborder">max: { this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.insertion_loss_max : ""}</td>
                            </tr>
                            <tr>
                                <td className="textalignright">typ: { this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.insertion_loss_typ : ""}</td>
                            </tr>
                            <tr>
                                <td>Return Loss:</td>
                                <td>min. { this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.return_loss : ""}</td>
                            </tr>
                            <tr>
                                <td>Weight:</td>
                                <td>{ this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.weight.toFixed(2)  : ""}kg / { this.props.order.product != null && "product_details" in this.props.order.product ? Math.round((this.props.order.product.product_details.weight * 2.20462262185)).toFixed(2) : ""}lbs</td>
                            </tr>
                            <tr>
                                <td>opticalCON Cable Type</td>
                                <td>{ this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.product_type : ""}</td>
                            </tr>
                            <tr>
                                <td>{ (this.props.order.product_type !== null && (this.props.order.product_type === "split" || this.props.order.product_type === "powersplit" || this.props.order.product_type === "powersplit25")) ? "SPLIT" : ""} Connector Type</td>
                                <td>{ this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.connector_type : ""}</td>
                            </tr>
                            <tr>
                                <td>Fiber Type</td>
                                <td>{ this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.fiber_type : ""}</td>
                            </tr>
                            <tr>
                                <td>Cable Type</td>
                                <td>{ this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.cable_type : ""}</td>
                            </tr>
                            <tr>
                                <td>Cable Length</td>
                                <td>{this.props.order.cable_length !== null ? this.props.order.cable_length : ""}m. ({ this.props.order.cable_length !== null ? Math.round((this.props.order.cable_length * 3.2808)).toFixed(2) : ""}ft.)</td>
                            </tr>
                            <tr>
                                <td>Packaging</td>
                                <td>{ this.props.order.product !== null && "product_details" in this.props.order.product ? this.props.order.product.product_details.packaging : ""}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    }

                    { this.props.order.product !== null && "price" in this.props.order.product &&
                    <div>
                        <div className="item-heading">Pricing and Conditions</div>
                        <table cellPadding="0" cellSpacing="0" className="parts">
                            <thead>
                            <tr>
                                <th>Tier</th>
                                <th>Price / pc.</th>
                            </tr>
                            </thead>
                            <tbody>
                            {price_tiers_table}
                            </tbody>
                        </table>
                    </div>
                    }
                </div>
                <div className="closer" onClick={() => this.hideProductDetails()}>
                    <div className="triangle"></div>
                </div>
            </div>
        );
    }
}

ProductDetails = withRouter(ProductDetails);

const mapStateToProps = state => ({
    routing: state.routing,
    config: state.config,
    order: state.order,
    user: state.user,
    cart: state.cart
})

const mapDispatchToProps = dispatch => bindActionCreators({
    resetOrder,
    setQuantity,
    setPriceTier,
    setCurrency,
    addProduct
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductDetails)



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/app/product_details.js